(function () {
  var OFFERS = ['offer_access', 'offer_founding', 'offer_gift', 'offer_bundle'];
  var KEY = 'ambra_offer';
  var form = document.getElementById('contact_form');
  if (!form) return;

  // Read utm_content once and keep it for the session. Only the four known offer values count.
  var offer = null;
  try {
    var p = new URLSearchParams(window.location.search).get('utm_content');
    if (p && OFFERS.indexOf(p) > -1) { sessionStorage.setItem(KEY, p); }
    offer = sessionStorage.getItem(KEY);
  } catch (e) {}

  // Adds the offer to the hidden contact[tags] field (newsletter,offer_x). Never throws.
  function applyTag() {
    try {
      var tags = form.querySelector('input[name="contact[tags]"]');
      if (tags && offer && OFFERS.indexOf(offer) > -1 && tags.value.indexOf(offer) === -1) {
        tags.value = tags.value + ',' + offer;
      }
    } catch (e) {}
  }
  applyTag();

  var alreadyFired = false;

  form.addEventListener('submit', function () {
    applyTag();
    if (alreadyFired) return;
    alreadyFired = true;

    if (typeof fbq === 'function') {
      fbq('track', 'Lead', { content_name: 'Waitlist Signup' });
    }
  });
})();